import ReduxSagaFirebase from '../libs/ReduxSagaFirebase';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/database';
import 'firebase/compat/storage';
import 'firebase/compat/auth';
import 'firebase/compat/app-check';
import 'firebase/compat/functions';
import '@firebase/firestore';

const prodConfig = {
  apiKey: 'AIzaSyBnpHmTYEn8Bd2qJwugbWq0oWPwR-1eas8',
  authDomain: 'survcart.firebaseapp.com',
  databaseURL: 'https://survcart-default-rtdb.firebaseio.com',
  projectId: 'survcart',
  storageBucket: 'survcart.appspot.com',
  messagingSenderId: '440493000671',
  appId: '1:440493000671:web:8275061ced8b362dbde66a',
  measurementId: 'G-LJNR91ZM7W',
  timestampsInSnapshots: true,
};

const devConfig = {
  apiKey: 'AIzaSyBtQ9Uqxn4Ul5maJ1XaLIDwwhS3x8BboDg',
  authDomain: 'survcart-dev.firebaseapp.com',
  projectId: 'survcart-dev',
  storageBucket: 'survcart-dev.appspot.com',
  messagingSenderId: '157221417844',
  appId: '1:157221417844:web:eba31faaeb78b4f7103221',
  measurementId: 'G-WNVKS1FHHY',
  timestampsInSnapshots: true,
};

let config =
  window.location.hostname === 'app.survcart.com' ? prodConfig : devConfig;

if (window.location.hostname === 'localhost') {
  if (window.localStorage.survcartTargetEnv === 'prod') {
    config = prodConfig;
  } else {
    config = devConfig;
  }
}

var defaultApp = firebase.initializeApp(config);
window.docketConfig =
  defaultApp.options.authDomain == prodConfig.authDomain ? 'prod' : 'dev';

let firestore = defaultApp.firestore();
const analytics = defaultApp.analytics;
const auth = defaultApp.auth();
const functions = defaultApp.functions();
const database = defaultApp.database();
const storage = defaultApp.storage();
const publicStorage = defaultApp.storage(
  `gs://images.survcart.${window.docketConfig === 'dev' ? 'dev' : 'com'}`,
);
const messaging = defaultApp.messaging;
if (
  process.env.VITE_WITH_EMULATED_FIREBASE &&
  process.env.VITE_WITH_EMULATED_FIREBASE.toLowerCase() === 'true'
) {
  auth.useEmulator(
    `http://localhost:${process.env.VITE_SURVCART_EMULATED_AUTH_PORT}`,
    { disableWarnings: true },
  );
  database.useEmulator('localhost', process.env.VITE_SURVCART_EMULATED_DB_PORT);
  firestore.useEmulator(
    'localhost',
    process.env.VITE_SURVCART_EMULATED_FIRESTORE_PORT,
    {
      mockUserToken: {
        sub: '1',
        super: true,
      },
    },
  );
  functions.useEmulator(
    'localhost',
    process.env.VITE_SURVCART_EMULATED_FUNCTIONS_PORT,
  );
  storage.useEmulator(
    'localhost',
    process.env.VITE_SURVCART_EMULATED_STORAGE_PORT,
  );
  publicStorage.useEmulator(
    'localhost',
    process.env.VITE_SURVCART_EMULATED_STORAGE_PORT,
  );
}

const rsf = new ReduxSagaFirebase(defaultApp, firestore);

export const reduxSagaFirebase = rsf;

export const db = firestore;

export const firebaseApp = {
  firestore,
  analytics,
  auth,
  storage,
  publicStorage,
  rsf,
  app: defaultApp,
};

export { firestore, analytics, auth, storage, publicStorage, rsf, messaging };
